// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__V6mgg","img":"Logo_img__fNheY"};